"use strict";
/**
 * Copyright © 2019 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var lodash_1 = require("lodash");

var core_1 = require("@bodiless/core");

var mobx_react_lite_1 = require("mobx-react-lite");

var withFloatWrapper = function withFloatWrapper(Component) {
  return mobx_react_lite_1.observer(function (props) {
    var node = core_1.useNode().node; // @ts-ignore

    var className = {
      left: 'float-left relative z-10',
      right: 'float-right relative z-10',
      justify: 'flex justify-center'
    }[node.data.float || 'justify'];
    return react_1.default.createElement("div", {
      className: className
    }, react_1.default.createElement(Component, __assign({}, props)));
  });
};

var useMenuOptions = function useMenuOptions() {
  var node = core_1.useNode().node;
  var menuOptions = react_1.useMemo(function () {
    return [{
      icon: 'format_align_left',
      name: 'Float Left',
      handler: function handler() {
        return node.setData({
          float: 'left'
        });
      },
      local: true,
      global: true
    }, {
      icon: 'format_align_justify',
      name: 'Center',
      handler: function handler() {
        return node.setData({
          float: 'justify'
        });
      },
      local: true,
      global: true
    }, {
      icon: 'format_align_right',
      name: 'Float Right',
      handler: function handler() {
        return node.setData({
          float: 'right'
        });
      },
      local: true,
      global: true
    }];
  }, []);
  return menuOptions;
};

var asFloat = lodash_1.flowRight(withFloatWrapper, core_1.ifEditable(core_1.withMenuOptions({
  useMenuOptions: useMenuOptions,
  name: 'float'
}), core_1.withLocalContextMenu, core_1.withContextActivator('onClick')));
exports.default = asFloat;